import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './BookingBanner.css';

const BookingBanner = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [shouldRender, setShouldRender] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const isProtectedRoute = location.pathname.startsWith('/personal_account');

        // Если защищенный маршрут - скрываем
        if (isProtectedRoute) {
            setIsVisible(false);
            // Даем время на анимацию исчезновения, потом удаляем из DOM
            setTimeout(() => setShouldRender(false), 400);
            return;
        }

        // Для публичных страниц - показываем
        setShouldRender(true);

        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 5000);

        return () => clearTimeout(timer);
    }, [location.pathname]);

    // Если не нужно рендерить - возвращаем null
    if (!shouldRender) {
        return null;
    }

    return (
        <div className={`booking-banner ${isVisible ? 'visible' : ''}`}>
            <div className="banner-content">
                {/*<span className="banner-icon">📅</span>*/}
                <a href='https://calendly.com/fortres-sales/fortres-bancorp-meeting'  className="banner-text">Schedule a meeting </a>
            </div>
            <button
                className="banner-close"
                onClick={() => setIsVisible(false)}
                aria-label="Закрыть"
            >
                ✕
            </button>
        </div>
    );
};

export default BookingBanner;